import UserInfoPanel from './UserInfoPanel';

export default UserInfoPanel;
